import styled from 'styled-components';

import { Heading } from '@makemydeal/dr-ui-bricks-components';
import type { HeadingLevel } from '@makemydeal/dr-ui-bricks-types';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';
import { RESPONSIVE_HEADING_SIZES } from '../../typography/responsiveHeadingSizes';

/**
 * ResponsiveDescription
 *
 * Styled extension of the shared `Heading` primitive for page descriptions.
 * The `level` prop is read at runtime so the correct row of `RESPONSIVE_HEADING_SIZES`
 * is applied — no hardcoded level index anywhere:
 *   • Desktop  (default)  →  RESPONSIVE_HEADING_SIZES[level].desktop
 *   • Tablet   ≤ 1279px   →  RESPONSIVE_HEADING_SIZES[level].tablet
 *   • Mobile   ≤  767px   →  RESPONSIVE_HEADING_SIZES[level].mobile
 */
export const ResponsiveDescription = styled(Heading)`
    @media (max-width: ${BreakPoints.TABLET}) {
        font-size: ${({ level = 5 as HeadingLevel }) => RESPONSIVE_HEADING_SIZES[level].tablet.fontSize};
        line-height: ${({ level = 5 as HeadingLevel }) => RESPONSIVE_HEADING_SIZES[level].tablet.lineHeight};
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        font-size: ${({ level = 5 as HeadingLevel }) => RESPONSIVE_HEADING_SIZES[level].mobile.fontSize};
        line-height: ${({ level = 5 as HeadingLevel }) => RESPONSIVE_HEADING_SIZES[level].mobile.lineHeight};
    }
`;
